import dayjs from "dayjs";
import store from "../store"; 
import {
  createAddMessageAction,
  createSetLodingAction,
} from "../store/actions";
import relativeTime from "dayjs/plugin/relativeTime"; 
import { Decimal } from 'decimal.js';

export function toThousands(num: string) {
  let numArr = num.split(".");
  if (numArr.length > 1) {
    return parseFloat(numArr[0]).toLocaleString() + "." + numArr[1];
  } else {
    return parseFloat(numArr[0]).toLocaleString();
  }
}
//用户地址处理方法
export function AddrHandle(
  addr: string,
  start = 4,
  end = 4,
  replace = "..."
): string | undefined {
  if (!addr) {
    return;
  }
  let r = new RegExp("(.{" + start + "}).*(.{" + end + "})");
  let addrArr: RegExpMatchArray | null = addr.match(r);
  return addrArr![1] + replace + addrArr![2];
}
export function HowLongAgo(time: number) {
  dayjs.extend(relativeTime);
  var a = dayjs();
  return a.to(new Date(time));
}

export function GetQueryString(name: string) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  // console.log(window.location)
  var r = window.location.search.slice(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

export function JudgmentNumber(number: string) {
  let numArr = number.split(".");
  if (numArr.length > 1) {
    return numArr[1].length > 18;
  }
  return false;
}
// 不四舍五入
export function NumSplic(val: any, len: number = 6) {
  var f = parseFloat(val);
  if (isNaN(f)) {
    return false;
  }
  var s = val.toString();
  if (s.indexOf(".") > 0) {
    let f = s.split(".")[1].substring(0, len);
    s = s.split(".")[0] + "." + f;
  }
  var rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + len) {
    s += "0";
  }
  return s;
}
// 不补0
export function NumSplic1(val: any, len: number = 6) {
  if (val < 0.00001) {
    return '<0.00001';
  }
  var f = parseFloat(val);
  if (isNaN(f)) {
    return false;
  }
  var s = val.toString();
  if (s.indexOf(".") > 0) {
    let f = s.split(".")[1].substring(0, len);
    s = s.split(".")[0] + "." + f;
  }
  return s;
}
// 截断小数（不四舍五入）
export function getBit(value: number, bit = 5) {
  let str = value.toString();
  let strIndex = str.indexOf(".");
  if (strIndex === -1) return str;
  str = str.substring(0, strIndex + bit);
  // console.log(str, bit);
  // console.log(typeof str,'getBit值')
  return str;
}
export function formatAmount(data: number) {
  let output = data;
  if (data < 1000) {
    return getBit(data, 5);
  }
  else if (data >= 1000 && data < 1000000) {
    output = new Decimal(`${data}`).dividedBy(1000).toNumber();
    return `${output.toFixed(1)}K`
  } else if (data < 1000000000 && data >= 1000000) {
    output = new Decimal(`${data}`).dividedBy(1000000).toNumber();
    return `${output.toFixed(1)}M`
  } else if (data >= 1000000000) {
    output = new Decimal(`${data}`).dividedBy(1000000000).toNumber();
    return `${output.toFixed(1)}B`
  }
  return data;
}

export function numberDivision() { }

export function showLoding(isShow: boolean) {
  store.dispatch(createSetLodingAction(isShow));
}

export function addMessage(msg: string) {
  store.dispatch(
    createAddMessageAction({
      message: msg,
      index: store.getState().message.length,
    })
  );
} 
export function dateFormat(fmt: string, date: Date) {
  let ret;
  const opt: { [key: string]: string } = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
export function getFullNum(num: any) {
  //处理非数字
  if (isNaN(num)) {
    return num;
  }
  //处理不需要转换的数字
  var str = "" + num;
  if (!/e/i.test(str)) {
    return num;
  }
  return num.toFixed(18).replace(/\.?0+$/, "");
}

//获取小数点后面有几个连续的0

export function countLeadingZerosAfterDecimal(n: string) {
  try {
    const str = n.toString();
    const decimalPart = str.split('.')[1] || '';
    const match = decimalPart.match(/^0+/); // 匹配小数点后的前导0
    return match ? match[0].length : 0;
  } catch (error) {
    return 0;
  }
}

export function startWord(name: string) {
  if (name.startsWith("/View")) return name.slice(5);
  return "";
}

//时间戳转日期的函数
export function timestampToDateString(timestamp: any) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const dateString = `${month}/${day} ${hours}:${minutes}`;
  return dateString;
}

export function formatTimestamp(timestamp: any) {
  const date = new Date(timestamp);

  const Y = date.getFullYear();
  const M = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
  const D = String(date.getDate()).padStart(2, '0');

  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');

  return `${Y}/${M}/${D} ${h}:${m}:${s}`;
}

// 把时间戳转为utc0时间戳
export function convertToLocalUtc0Timestamp(timeString: number): number {
  // 解析本地时间字符串
  const localDate = new Date(timeString);

  // 获取本地时间相对于 UTC 的偏移量（以分钟为单位）
  const offset = localDate.getTimezoneOffset();

  // 创建一个新的 Date 对象，表示 UTC 0 时区的时间
  const utc0Date = new Date(localDate.getTime() + offset * 60 * 1000);

  // 返回 UTC 0 时区的时间戳
  return utc0Date.getTime();
}

//input禁止输入中文
export function handleBeforeInput(event: any) {
  const regex = /[\u4e00-\u9fff]/;
  return regex.test(event);
}

export function formatTimestamp2(timestamp: number): string {
  const date = new Date(timestamp);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}·${day}`;
}

export function ToThousand(
  num: string | number,
  decimalPlaces?: number
): string {
  // 将输入转换为数字
  let parsedNum = typeof num === "string" ? parseFloat(num) : num;

  // 检查是否为有效数字
  if (isNaN(parsedNum)) {
    throw new Error("Invalid number");
  }

  // 如果指定了小数位数，则进行四舍五入
  if (decimalPlaces !== undefined) {
    parsedNum = parseFloat(parsedNum.toFixed(decimalPlaces));
  }

  // 处理负数
  const sign = parsedNum < 0 ? "-" : "";
  parsedNum = Math.abs(parsedNum);

  // 转换为字符串并分割整数和小数部分
  const parts = parsedNum.toString().split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];

  // 添加千位分隔符
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  // 组合整数和小数部分
  if (decimalPart) {
    return sign + formattedIntegerPart + "." + decimalPart;
  } else {
    return sign + formattedIntegerPart;
  }
}
 
export function formatScientificNotation(num: number | string): string {
  const numStr = typeof num === 'number' ? num.toString() : String(num);

  // 处理科学计数法 (如 2.249e-9)
  if (numStr.includes('e-')) {
    const [base, exponentStr] = numStr.split('e-');
    const exponent = parseInt(exponentStr, 10);
    const [integerPart, decimalPart = ''] = base.split('.');

    const leadingZeros = exponent - 1;
    const digits = (integerPart + decimalPart).slice(0, 8); // ⬅️ 保留最多8位有效数字

    return `0.0${toSubscript(leadingZeros)}${digits}`;
  }

  // 处理普通小数格式 (如 0.000000002249)
  if (numStr.startsWith('0.')) {
    const decimalPart = numStr.split('.')[1];
    const leadingZeros = decimalPart.match(/^0+/)?.[0]?.length || 0;
    const remainingDigits = decimalPart.slice(leadingZeros).slice(0, 8); // ⬅️ 保留最多8位

    if (leadingZeros > 0) {
      return `0.0${toSubscript(leadingZeros)}${remainingDigits}`;
    }
  }

  // fallback 普通格式（非小数），直接截取前8位
  return String(num).slice(0, 8);
}


// 辅助函数：将数字转换为下标字符
function toSubscript(num: number): string {
  const subscriptDigits = '₀₁₂₃₄₅₆₇₈₉';
  return num.toString().split('').map(d => subscriptDigits[parseInt(d)]).join('');
}

// 获取当前时间
export function getFormattedTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
  const day = String(now.getDate()).padStart(2, '0');

  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  const second = String(now.getSeconds()).padStart(2, '0');

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}

// 定义函数类型 + 自定义属性
type IsMobileFunction = {
  (): boolean;
  __listenerAdded?: boolean; // 标记是否已添加监听器
};
const isMobile: IsMobileFunction = () => {
  // 1. 闭包内的缓存变量
  let cachedIsMobile: boolean | null = null;
  let lastWindowWidth: number | null = null;

  // 2. 实际检测逻辑
  const check = (): boolean => {
    if (cachedIsMobile === null || window.innerWidth !== lastWindowWidth) {
      lastWindowWidth = window.innerWidth;
      cachedIsMobile = (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        window.innerWidth < 768
      );
    }
    return cachedIsMobile;
  };

  // 3. 自动初始化监听器（只执行一次）
  if (!isMobile.__listenerAdded) {
    let resizeTimer: number;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        cachedIsMobile = null; // 窗口变化时清除缓存
      }, 200);
    });
    isMobile.__listenerAdded = true;
  }

  // 4. 返回检测结果
  return check();
};
export { isMobile };

export function isNumber(str: any) {
  return typeof str === 'string' && !isNaN(Number(str));
}

// 滚动到顶部
export function scrollToTop() {
  // 尝试滚动 body
    document.body.scrollTo(0, 0);

    // 尝试滚动 document.documentElement (html 元素)
    document.documentElement.scrollTo(0, 0);

    // 如果有其他滚动容器
    const mainContainer = document.querySelector('#root');
    if (mainContainer) {
      mainContainer.scrollTo(0, 0);
    }
}
// 清除所有cookie
export function clearAllCookies() {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
}
// 判断字符串中文还是英文
export function detectLanguage(str: any) {
  // 统计中文字符和英文字符的数量
  let chineseCount = 0;
  let englishCount = 0;
  let otherCount = 0; 
  for (let char of str) {
    if (/[\u4e00-\u9fa5]/.test(char)) {
      chineseCount++;
    } else if (/[a-zA-Z]/.test(char)) {
      englishCount++;
    } else {
      otherCount++;
    }
  } 
  // 根据比例判断主要语言
  if (chineseCount > englishCount) {
    return 'Chinese';
  } else if (englishCount > chineseCount) {
    return 'English';
  } else {
    return 'Mixed or Other';
  }
}

 // 检查字符串是否包含 'script'（兼容 undefined/null/非字符串） 
 export function containsScript(str: any) {
  return typeof str === 'string' && str.toLowerCase().includes('script');
}